export default __webpack_public_path__ + "static/media/dark-dark-theme-icon.159b6b5e.svg";